export const environment = {
  production: true,
  tessellonPortalLoginUrl: 'https://apps.tessellon.com',
  tessellonApiBaseUrl: 'https://apigateway.tessellon.com',
  vennHealthBaseUrl: 'vennhealth',
  userNameUrl: 'username',
  diagnosisCodesListUrl: 'dxcodes',
  procedureCodesListUrl: 'procodes',
  diagnosisCodesSearchUrl: 'search/dxcodes',
  procedureCodesSearchUrl: 'search/procodes',
  cmCodeDetailsUrl: 'cmcodes/description',
  pcsCodeDetailsUrl: 'pcscodes/description',
  selectedCmCodesUrl: 'cmcodes/selectedcodes',
  selectedPcsCodesUrl: 'pcscodes/selectedcodes',
  pcsCodeBuilderUrl: 'search/pcs',
  savedFilterNamesUrl: 'savedfilternames',
  savedFilter: 'savedfilter',
  loadCohortGroupUrl: 'cohortGroup',
  loadCohortGroupsListUrl: 'clientcohortgroups',
  saveCohortGroupUrl: 'savecohortgroup',
  deleteCohortGroupUrl: 'deletecohortgroup',
  deleteSavedFilterUrl: 'deletesavedfilter',
  runQueryUrl: 'query',
  saveFiltersUrl: 'savefilters',
  renameFilterUrl: 'renamefilter',
  logExecutedQueryStartUrl: 'logquerystart',
  executedQueriesListUrl: 'executedqueries',
  executedQueryUrl: 'executedQuery',
  defaultDiagnosisQueryName: 'Diagnosis Query',
  defaultProcedureQueryName: 'Procedure Query',
  defaultQueryName: 'Query'
};
